import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';
import { cn } from '@/utils/cn-tw-merge';

type BannersSectionLoadingDesktopProps = React.HTMLAttributes<HTMLDivElement>;

export const BannersSectionLoadingDesktop = ({ className }: BannersSectionLoadingDesktopProps) => {
  return (
    <div className={cn('bg-gray-100 mt-6 pt-8 pb-10', className)}>
      <ContentContainer>
        <div className="flex items-center gap-4 -mx-10">
          <Skeleton className="w-7 h-7 rounded" />

          <div className="flex gap-2 w-full">
            {Array.from({ length: 3 }).map(() => (
              <Skeleton key={crypto.randomUUID()} className="w-full h-28 rounded" />
            ))}
          </div>

          <Skeleton className="w-7 h-7 rounded" />
        </div>
      </ContentContainer>
    </div>
  );
};
